export default __webpack_public_path__ + "static/media/tree9.a9135831.png";